export const getFromLocalStorage = (name) => {
  try {
    return JSON.parse(localStorage.getItem(name));
  } catch (error) {
    return localStorage.getItem(name);
  }
};

export const removeFromLocalStorage = (name) => localStorage.removeItem(name);
